import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom"
import AllUsers from './Dashboard/AllUsers';
import Login from './Dashboard/Login';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './settings';
import { AuthProvider } from './Hooks/useAuth';
import UserDetails from './Dashboard/UserDetails';

function App() {
  return (
    <div>
      <BrowserRouter>
        <AuthProvider>
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <Routes>
              <Route exact path="/" element={ <Login /> } />
              <Route exact path="/users" element={ <AllUsers /> } />
              <Route exact path="/user-details/:chosenRange/:email" element={<UserDetails />} />
            </Routes>
          </GoogleOAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
